const AtividadesSection = ({ onSelectCard }) => (
  <section className="atividades">
    <h2>Projetos e Iniciativas</h2>
    <div className="cartas">
      <div className="carta" onClick={() => onSelectCard('Jogos')}>
        <h3>Jogos Internos</h3>
      </div>
      <div className="carta" onClick={() => onSelectCard('Aulas')}>
        <h3>Aulas Práticas</h3>
      </div>
      <div className="carta" onClick={() => onSelectCard('CNA')}>
        <h3>CNA Inglês</h3>
      </div>
      <div className="carta" onClick={() => onSelectCard('SEE')}>
        <h3>SEE</h3>
      </div>
    </div>
  </section>
);

export default AtividadesSection;
